import { Component, inject } from '@angular/core';
import { ModalService } from 'src/utils/modal.service';
import { ToastService } from 'src/utils/toast.service';
import { ButtonsComponent } from './buttons/buttons.component';
import { DropdownSimpleComponent } from './dropdowns/simple/dropdown-simple.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CountryService } from 'src/utils/country.service';
import { SelectorPhoneCountry } from '../interfaces/selector-country.interfaces';
import { HttpClientModule } from '@angular/common/http';
import { TabComponent } from './tab/tab.component';
import { TabsComponent } from './tabs/tabs.component';
import { TableComponent } from './tables/table/table.component';
import { MOCK_COLUMNS, TABLE_MOCK_DATA } from './tables/table/table.mock';
import { SelectorComponent } from './selectors/simple/selector.component';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ButtonsComponent,
    DropdownSimpleComponent,
    CheckboxComponent,
    HttpClientModule,
    TabComponent,
    TabsComponent,
    TableComponent,
    SelectorComponent,
  ],
  templateUrl: './component-test.component.html',
})
export class ComponentTest {
  public modalService = inject(ModalService);
  public toastService = inject(ToastService);
  countries: SelectorPhoneCountry[] = [];
  columns = MOCK_COLUMNS;
  users = TABLE_MOCK_DATA;

  testForm: FormGroup;

  constructor(private fb: FormBuilder, private countryService: CountryService) {
    this.testForm = this.fb.group({
      phone: ['', Validators.required],
    });
  }

  filterOptions = {
    estado: [
      { label: 'Activo', value: 'activo' },
      { label: 'Inactivo', value: 'inactivo' },
    ],
    tipoCarga: [
      { label: 'Manual', value: 'manual' },
      { label: 'Automática', value: 'automatica' },
    ],
  };

  filterLabels = {
    estado: 'Estado',
    tipoCarga: 'Tipo de carga',
  };

  ngOnInit() {
   
  }

  onSubmit() {
    console.log('Formulario enviado:', this.testForm.value);
  }

  showToast(): void {
    this.toastService.showToast(
      'fi fi-ss-check-circle text-[24px] text-[#17BF33]',
      'hubo un problema al colocar tu contraseña intenta de nuevo por favor',
      'success'
    );
  }

  showModal(): void {
    this.modalService.showModal({
      title: '¡Tu cuenta está casi lista!',
      message:
        'Completa la segmentación para activar todas las herramientas de PRECREDIT Advanced.',
      onConfirm: () => {
        console.log('Usuario hizo clic en Continuar');
      },
      modalType: 'success',
      iconClass: 'fi fi-ss-check-circle text-4xl text-success',
      btnCancelar: false,
      continueButtonText: 'Continuar',
    });
  }
  showModal2(): void {
    this.modalService.showModal({
      title: '¿Estás seguro de que deseas cerrar sesión?',
      message: '',
      onConfirm: () => {},
      modalType: 'confirmation',
      btnCancelar: true,
      cancelButtonText: 'Cancelar',
      continueButtonText: 'Cerrar sesión',
      iconClass: 'fi fi-sr-exclamation text-4xl text-error',
    });
  }
  showModal3(): void {
    this.modalService.showModal({
      title: '¿Deseas cancelar?',
      message:
        'Solo faltan unos pasos para completar tu cuenta en PRECREDIT Advanced. Salir ahora dejará tu registro incompleto.',
      onConfirm: () => {},
      modalType: 'warning',
      iconClass: 'fi fi-sr-diamond-exclamation text-4xl text-error',

      btnCancelar: true,
      cancelButtonText: 'Cancelar',
      continueButtonText: 'Salir sin guardar',
    });
  }

  onPhoneChange(value: string) {
    console.log('Número emitido:', value);
  }

  onSearch(text: string) {
    console.log('Buscar:', text);
  }

  onPageChange({ page, limit }: { page: number; limit: number }) {
    console.log('Página:', page);
    console.log('Límite:', limit);
  }

  onSort(event: { column: string; direction: 'asc' | 'desc' }) {
    console.log('Ordenar:', event);
  }

  onTableAction(event: { row: any; action: string }) {
    console.log('Acción:', event);
  }

  onEdit(row: any) {
    console.log('Editar:', row);
  }

  onDelete(row: any) {
    console.log('Eliminar:', row);
  }

  onToggle(event: { row: any; checked: boolean }) {
    console.log('Fila:', event.row, 'Estado:', event.checked);
  }

  handleSelectionChange(value: any) {
    console.log('Opción seleccionada:', value);
  }
}